/*
 *
 * Package: `@dbh/price-details-theme`.
 *
 */const THEME_KEY_PRICE_DETAILS="priceDetails";const priceDetails={priceDetails:{additionalInfosWrapper:{justifyContent:"right",alignItems:"flex-end"}}};

export { THEME_KEY_PRICE_DETAILS, priceDetails as default };
